import configData from '../common/configData.json';

const defaultCountryCode = configData?.common.vn.countryCode;

export const getIsBTPEndpoint = (selectedCountryCode) => {
    const countryCode = selectedCountryCode ?? defaultCountryCode;
    return configData?.common[countryCode]?.BTPEndpoint;
}

const getMsMuleEndpoint = (countryCode) => {
    switch (countryCode) {
        case 'id':
            return configData.mulesoftConfig.microserviceEndpointId;
        case 'idic':
            return configData.mulesoftConfig.microserviceEndpointIdIc;
        case 'pk':
            return configData.mulesoftConfig.microserviceEndpointPk;
        case 'bd':
            return configData.mulesoftConfig.microserviceEndpointPk;
        default:
            return configData.mulesoftConfig.microserviceEndpoint;
    }
};

export const getClientId = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTP_client_id : configData.mulesoftConfig.client_id;
}

export const getClientSecret = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTP_client_secret : configData.mulesoftConfig.client_secret;
}

export const getEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPEndpoint : configData.mulesoftConfig.muleEndpoint;
}

export const getExpEndpoint = (countryCode) => {
    const muleExpEndpoint =  countryCode === "idic"  
                            ? configData.mulesoftConfig.muleExpEndpointIdIc
                            : configData.mulesoftConfig.muleExpEndpoint
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPExpEndpoint : muleExpEndpoint;
}

export const getMicroserviceEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPMicroserviceEndpoint : getMsMuleEndpoint(countryCode);
}

export const getCheckstatusEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? 'file/checkstatus' : 'exp/file/checkstatus';
}

export const getUploadEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? 'file/upload' : 'exp/file/upload';
}

export const getDownloadEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? 'file/download/' : 'exp/file/download/';
}